import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API
});

apiClient.interceptors.request.use(request => {
  return new Promise(function (resolve /*, reject*/) {
    let token = localStorage.getItem('rekom.life.accessToken');

    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
      request.headers.AccessToken = token;
    }


    resolve(request);
  });
});

apiClient.interceptors.response.use(undefined, error => {
  console.log(error);

  // Errors handling
  const { response } = error;
  const { data } = response;

  if (data) {
    console.log("Warning - API:", data);
    throw (data);
  }
  else {
    throw ("unknown error")
  }
});


export default apiClient;
